import Vue from 'vue';
import Component from 'vue-class-component';
import { FILTER_PRESENTATION_USERS_EVENT } from '@/content/values/ed-presentation-mode.values';
import { MEETINGS_STORE } from '@/meetings/store/meetings.store';

@Component({})
export default class EdPresentationModeUserFilter extends Vue {

  public switchToggle: boolean = true;
  public tooltipTitle: string = '';
  public labelActive: string = '';
  private filerValues: { [key: string]: any } = {};
  
  get presentationModeUserFilter() {
    return this.$store.state.MeetingsStore.presentationModeUserFilter;
  }

  public onChange(): void {
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_MODE_USER_FILTER, this.switchToggle);
    this.$edEventBus.$emit(FILTER_PRESENTATION_USERS_EVENT, this.switchToggle);
    this.tooltipTitle = this.filerValues[this.switchToggle.toString()].tooltipTitle;
    this.labelActive = this.filerValues[this.switchToggle.toString()].labelActive;
  }

  private buildFilterValues(): void {
    this.filerValues = {
      true: {
        tooltipTitle: `${this.$t('meetings.presentationMode.showAll')}`,
        labelActive: `${this.$t('meetings.presentationMode.showAll')}`
      },
      false: {
        tooltipTitle: `${this.$t('meetings.presentationMode.showOnlineOnly')}`,
        labelActive: `${this.$t('meetings.presentationMode.showOnlineOnly')}`
      }
    };
  }

  private setPresentationModeUserFilter(){
    this.switchToggle = this.presentationModeUserFilter;
    this.onChange();
  }

  mounted() {
    this.buildFilterValues();
    this.setPresentationModeUserFilter();
    this.tooltipTitle = this.filerValues[this.switchToggle.toString()].tooltipTitle;
    this.labelActive = this.filerValues[this.switchToggle.toString()].labelActive;
  }

}